module.exports = __webpack_public_path__ + "static/media/group-22.e5dba130.svg";